import { useEffect, useState } from 'react'
import GuideList from '../components/GuideList'
import { loadGuides } from '../lib/guides'
import { GuideSummary } from '../types/guides'

const GuidesPage = () => {
  const [guides, setGuides] = useState<GuideSummary[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    loadGuides()
      .then(items => {
        if (!cancelled) setGuides(items)
      })
      .catch(reason => {
        if (!cancelled) {
          setError(reason instanceof Error ? reason.message : '资料列表暂时无法加载')
        }
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-6xl px-4 py-10 md:py-14">
          <p className="text-sm font-medium text-slate-500">Parentool 资料库</p>
          <h1 className="mt-2 text-3xl font-semibold tracking-tight text-slate-950 md:text-4xl">资料库</h1>
          <p className="mt-3 max-w-2xl text-base leading-7 text-slate-600">
            亲子手册、出行指南、清单和家庭实用资料。
          </p>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-4 py-8 md:py-10">
        {isLoading && <p className="py-10 text-center text-sm text-slate-500" aria-live="polite">正在加载资料...</p>}
        {error && <p className="border-y border-slate-200 py-10 text-center text-sm text-slate-500" role="alert">{error}</p>}
        {!isLoading && !error && <GuideList guides={guides} showFilters />}
      </main>
    </div>
  )
}

export default GuidesPage
